export const binParticipationTooltip = {
    title: 'Bin Participation',
    body: "is calculated by comparing the fill quantity to today's actual market volume in the relevant time bin(s).",
};
export const averageParticipationTooltip = {
    title: 'Average Participation',
    body: "is your order's average participation rate from the start of the order until now.",
};

export const minParticipationRateTooltip = {
    title: 'Minimum Participation',
    body: 'is the minimum participation rate on your order',
};

export const maxParticipationRateTooltip = {
    title: 'Maximum Participation',
    body: 'is the maximum participation rate on your order',
};
